var _circle, _circle2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45.301,
    cy: 45.301,
    r: 45.301,
    fill: "#FF0000",
    fillOpacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.3008,
    cy: 45.3613,
    r: 26.5,
    fill: "#FF0000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1297_4708)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.7582 37.9297L50.8283 37.9999L50.7582 37.9297L44.9955 43.6923L39.2329 37.9297C39.0594 37.7562 38.8242 37.6588 38.5789 37.6588C38.3335 37.6588 38.0983 37.7562 37.9248 37.9297C37.7514 38.1032 37.6539 38.3384 37.6539 38.5837C37.6539 38.8291 37.7514 39.0643 37.9248 39.2378L43.6874 45.0004L37.9248 50.763C37.7514 50.9365 37.6539 51.1718 37.6539 51.4171C37.6539 51.6624 37.7514 51.8977 37.9248 52.0711C38.0983 52.2446 38.3336 52.342 38.5789 52.342C38.8242 52.342 39.0594 52.2446 39.2329 52.0711L44.9955 46.3085L50.7582 52.0711C50.9316 52.2446 51.1669 52.342 51.4122 52.342C51.6575 52.342 51.8928 52.2446 52.0662 52.0711C52.2397 51.8977 52.3372 51.6624 52.3372 51.4171C52.3372 51.1718 52.2397 50.9365 52.0662 50.763L46.3036 45.0004L52.0662 39.2378C52.2397 39.0643 52.3372 38.8291 52.3372 38.5837C52.3372 38.3384 52.2397 38.1032 52.0662 37.9297C51.8928 37.7562 51.6575 37.6588 51.4122 37.6588C51.1669 37.6588 50.9316 37.7562 50.7582 37.9297Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1297_4708"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.799,
    height: 19.799,
    fill: "white",
    transform: "translate(31 45) rotate(-45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailureIcon);
export default __webpack_public_path__ + "static/media/failure-icon.b362fd08ae7bc1b496fc6d3452ac3954.svg";
export { ForwardRef as ReactComponent };